import styled from 'styled-components';

const alturaHeader = 50;
const alturaFooter = 30;
const percentageSize = 1.3;
export const ValueDiv = styled.div`
  /* align-self: flex-end; */
`;
export const CardContainer = styled.div`
  display: block;
  /* width: 100%; */
  background-color: rgba(51, 51, 51, 0.95);
  border: ${({ selected }) => (selected ? '1px solid #c3a12d' : '1px solid #666')};
  border-radius: '5px';
  margin-right: ${({ mobile }) => (mobile ? 'none' : '1em')};
  margin-bottom: ${({ mobile }) => (mobile ? '1em' : 'none')};
  box-sizing: border-box;
  cursor: pointer;

  //mini-tablet || mobile rotated
  @media screen and (max-width: 768px) {
    height: fit-content;
  }

  @media screen and (min-width: 465px) {
    :hover {
      filter: drop-shadow(0 0 0.25rem #c3a12d);
    }
  }

  //mobile
  @media screen and (max-width: 464px) {
    height: fit-content;
    width: 100%;
  }
`;

export const CardWrapper = styled.div`
  display: grid;
  grid-template-rows: ${alturaHeader + 'px'} ${(props) => props.altura - alturaHeader * 2 - alturaFooter * 3 + 35 + 'px'} ${alturaFooter + 10 + 'px'};

  /* @media screen and (max-width: 1023px) {
    grid-template-rows: ${alturaHeader + 'px'} ${(props) => props.altura - alturaHeader * 2 - alturaFooter * 3 + 'px'} ${alturaFooter + 'px'};
  } */

  //mini-tablet || mobile rotated
  @media screen and (max-width: 768px) {
    display: block;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-left: 5px;
  padding-right: 5px;
  margin-left: 5px;
  margin-right: 5px;
  border: 0;
  border-bottom: 1px solid #777;
  @media screen and (max-width: 768px) {
    width: 95%;
  }
`;

export const ElementTitleWrapper = styled.div`
  color: white;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
`;

export const NomCapa = styled.div`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
  font-weight: 700;
  margin: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 380px;

  //mobile && tablet
  @media screen and (max-width: 768px) {
    width: 250px;
    font-weight: 600;
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 13 * percentageSize : 13)}px;
  }
`;

export const ElementTitle = styled.div`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
  color: white;
  text-decoration: none;
  margin: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 380px;
  @media screen and (max-width: 768px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 13 * percentageSize : 13)}px;
    width: 250px;
  }
`;

export const HeaderButtons = styled.div`
  display: none;
  flex-direction: row;
  justify-content: end;
  flex-wrap: wrap;
`;

export const HeaderBtn = styled.button`
  border: 0px;
  background-color: transparent;
`;

export const CardBody = styled.div`
  display: flex;
`;

export const BodyInfo = styled.article`
  overflow-y: scroll;
  overflow-x: hidden;
  color: white;
  padding: 5px;
  padding-left: 10px;
  width: 420px;

  ::-webkit-scrollbar {
    background-color: transparent;
    display: block;
    width: 7px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 1em;
  }

  ::-webkit-scrollbar-track {
    border-radius: 1em;
    margin-top: 5px;
    margin-left: 5px;
  }

  ::-webkit-scrollbar-track-piece :end {
    background-color: transparent;
    margin-bottom: 10px;
  }

  ::-webkit-scrollbar-track-piece :start {
    background-color: transparent;
    margin-bottom: 10px;
  }

  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }

  @media screen and (max-width: 464px) {
    width: 85%;
    height: 100%;
  }
`;

export const NomPunt = styled.h4`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 13 * percentageSize : 13)}px;
  font-weight: 500;
`;

export const InfoDesc = styled.p`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
  margin-bottom: 0;
  //tablet
  @media screen and (max-width: 1023px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 13 * percentageSize : 13)}px;
  }
`;

export const Parametre = styled.div`
  display: flex;
  gap: 5px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;

  //tablet
  @media screen and (max-width: 1023px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 13 * percentageSize : 13)}px;
  }
`;

export const NomParametre = styled.span`
  /* font-weight: bold; */
  width: 100%;
  flex: 0 0 auto;
  /* max-width: 60%; */
  //mini-tablet || mobile rotated
  @media screen and (max-width: 768px) {
    font-weight: 700;
  }
`;

export const NomParametreEdit = styled.span`
  /* font-weight: bold; */
  /* width: 100%; */
  flex: 0 0 auto;
  /* max-width: 70%; */
  //mini-tablet || mobile rotated
  @media screen and (max-width: 768px) {
    font-weight: 700;
  }
`;

export const RepresentacioGraficaWrapper = styled.div`
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const RepresentacioGrafica = styled.div`
  width: 3em;
  height: 3em;
  background-color: ${(props) => props.randomColor};
`;

export const CardFooter = styled.div`
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 2.5px;
  border: 0;
  border-top: 1px solid #777;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media screen and (max-width: 768px) {
    width: 95%;
  }
`;

export const LeftButtons = styled.div`
  display: flex;
  gap: 5px;
  flex-direction: row;
  justify-content: start;
  align-items: center;
`;

export const RightButtons = styled.div`
  display: flex;
  gap: 5px;
  flex-direction: row;
  justify-content: end;
  align-items: center;
`;

export const InfoCardButton = styled.button`
  border: 0px solid transparent;
  background-color: transparent;
  padding: 0;
  margin: 0;
`;

export const SvgIconWrapper = styled.div`
  transform: scale(0.8);
  filter: brightness(0) invert(1);
  vertical-align: middle;
  text-align: center;
  margin: auto;
  display: flex;
  display: ${({ hidden }) => (hidden ? 'none' : 'flex')};
`;

export const ButtonIcon = styled.img`
  vertical-align: middle;
  text-align: center;
  margin: auto;
  display: flex;
  transform: scale(0.8);
  filter: brightness(0) invert(1);
`;

export const CloseBtnWrapper = styled.svg.attrs((props) => ({
  fill: '#fff',
  cursor: 'pointer',
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24
}))``;

export const InfoPuntCardSVG = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24
}))``;

export const Link = styled.a`
  color: white;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;

  :hover {
    color: #febf00;
  }

  :visited {
    color: #febf00;
  }
`;

export const SVGNewTab = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  width: props.fontSizeEnabled ? 14 * percentageSize : 14,
  height: props.fontSizeEnabled ? 14 * percentageSize : 14
}))`
  margin-left: 5px;
  margin-right: 5px;
`;
export const CardEditInput = styled.input`
  background: transparent;
  border: none;
  padding: 0 0 0 4px;
  flex: 1;
  border-bottom: 1px solid white;
  color: white;
  width: 100%;
  margin-right: 10px;
  outline: none;
`;
export const CardEditButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 3px 0;
  gap: 10px;
`;
